import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import ConfirmForm from "../../components/forms/ConfirmForm";
import ProgressForm from "./CancelSubscriptionProgressForm";
import {cancelCancelSubscription} from "../../actions/AccountApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class CancelSubscriptionFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      requestId: "",
      view: "confirm"
    } 
  }

  handleSubmit(values) {
    return this.props.cancelSubscription(values.set("subscriptionId", this.props.subscriptionId).toJS())
      .then((response) => {
        if (response.data.cancelSubscription.errors.length <= 0) {
          console.log("request id: ", response.data.cancelSubscription.requestId);
          this.setState({view: "monitor", requestId: response.data.cancelSubscription.requestId});
        } else {
          let errors = createValidationErrors(response.data.cancelSubscription.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelCancelSubscription();
  }

  handleBack() {
    this.setState({view: "confirm"});
  }

  handleCompleted() {
    this.props.cancelCancelSubscription(); 
  }

  render() {
    if (this.state.view === "monitor") {
      return this.renderMonitorView();
    }
    return this.renderConfirmView();
  }


  renderConfirmView() {
    return (
      <ConfirmForm
        errors={this.state.errors}
        message="Are you sure you want to cancel this subscription?"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

  renderMonitorView() {
    return (
      <ProgressForm
        subscriptionId={this.props.subscriptionId}
        requestId={this.state.requestId}
        onBack={this.handleBack.bind(this)}
        onCompleted={this.handleCompleted.bind(this)}
        />
    )
  }      

}

const CANCEL_SUBSCRIPTION = gql`
  mutation cancelSubscription($subscriptionId: ID!) {
    cancelSubscription(subscriptionId: $subscriptionId) {
      requestId
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(CANCEL_SUBSCRIPTION, {
    props: ({ mutate }) => ({
      cancelSubscription: (data) => mutate({
        variables: data
      })
    })
  })
);

export default connect(null, {cancelCancelSubscription})(withQueries(CancelSubscriptionFormContainer));